import React from "react";
import { Tag } from "antd";

import FamiliesTable from "../FamiliesTable";
import FrequencyTable from "../FrequencyTable";

/**
 * Step 5 — coverage by procedure family.
 *
 * The replacement for today's "pick 16 representative codes and force each into
 * one of 4 categories". Rows are families; the category is a default we load and
 * the person on the call can change, because the same procedure genuinely sits
 * in different categories from one carrier to the next.
 */
export default function FamiliesStep({ values, onChange, carrier, frequency, onFrequencyChange }) {
  return (
    <div className="bw-card">
      <div style={{ display: "flex", alignItems: "center", justifyContent: "space-between", marginBottom: 4 }}>
        <p className="bw-card-title" style={{ marginBottom: 0 }}>Coverage by procedure family</p>
        <Tag color="purple">{(carrier || "Carrier") + " defaults loaded"}</Tag>
      </div>
      <p className="bw-hint" style={{ marginBottom: 16 }}>
        Categories start from this carrier's defaults. Change any that the plan treats
        differently — Endodontics, Oral Surgery and Perio Surgery are the ones that move most.
      </p>
      <FamiliesTable values={values} onChange={onChange} editable />

      {/* Frequency is asked at a finer grain than coverage — one row per
          procedure group, adult and child separately, as carriers quote it. */}
      <p className="bw-card-title" style={{ marginTop: 28 }}>Frequency by procedure group</p>
      <FrequencyTable values={frequency || {}} onChange={onFrequencyChange} editable />
    </div>
  );
}
